import { render } from "./VerifyingProductPage.vue?vue&type=template&id=0334ce91&scoped=true"
import script from "./VerifyingProductPage.vue?vue&type=script&lang=js"
export * from "./VerifyingProductPage.vue?vue&type=script&lang=js"

import "./VerifyingProductPage.vue?vue&type=style&index=0&id=0334ce91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0334ce91"]])

export default __exports__